import React, { useRef } from 'react';

import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import PlacementExportMenu from 'src/components/shared/placementExportMenu';
import useOpenCloseState from 'src/hooks/useOpenCloseState';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { useAppSelector } from 'src/store/store';

interface ActionsProps {
  placement: AssociateProfilePlacement;
}

const ExportActionMenu = ({ placement }: ActionsProps) => {
  const exportLinkRef = useRef<HTMLButtonElement>(null);
  const { isOpen: isExportMenuOpen, open: openExportMenu, close: closeExportMenu } = useOpenCloseState();
  const { selectedSite } = useAppSelector((state) => state.sites);

  return (
    <>
      <Button type="link" ref={exportLinkRef} onClick={openExportMenu}>
        Export <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <PlacementExportMenu
        placementId={placement.accommodationId.toString()}
        anchorRef={exportLinkRef}
        isMenuOpen={isExportMenuOpen}
        closeMenu={closeExportMenu}
        newestJmrFileName={placement.newestJmrFileName}
        countryId={selectedSite.countryId}
        allocatedJobShifts={placement.allocatedJobShifts}
        jobModificationsEnabled={selectedSite.jobModificationsEnabled}
      />
    </>
  );
};

export default ExportActionMenu;
